<template>
  <div class="shop-summary">
    <div class="shop-summary-navigation">
      <ButtonComponent
        :label="$t('goBack')"
        :icon="['fal', 'angle-left']"
        icon-placement="left"
        @click="$emit('prev')"
      />
    </div>
    <Selections :shop="shop" />
    <div class="shop-sidebar">
      <div class="shop-sidebar__header">
        <h2>{{ $t('pricing') }} ({{ $t('includingVat') }})</h2>
        <CostBreakdown :shop="shop" />
      </div>
      <div class="shop-cta">
        <slot name="summary">
          <LeadForm :shop="shop" />
        </slot>
      </div>
      <Contact :shop="shop" />
    </div>
  </div>
</template>

<script>
import CostBreakdown from './CostBreakdown.vue'
import Selections from './Selections.vue'
import Contact from '../Contact.vue'
import LeadForm from './LeadForm.vue'

export default {
  props: {
    shop: Object,
  },
  components: {
    CostBreakdown,
    Selections,
    Contact,
    LeadForm,
  },
}
</script>

<style lang="scss">
@import '../mixins.scss';

.shop-summary {
  --shop-summary-spacing: calc(var(--shop-spacing) * 1.5);
  --shop-header-background-dark: #{css-darken('shop-header-background', 3%)};

  display: grid;
  grid-template-columns: 3fr minmax(500px, 2fr);
  grid-template-areas: 'selections sidebar';

  min-height: 100dvh;

  @include onPhone {
    grid-template-columns: 1fr;
    grid-template-areas: 'navigation' 'sidebar' 'selections';

    --shop-summary-spacing: var(--shop-spacing);

    .shop-selections {
      max-height: initial !important;
      padding: var(--shop-summary-spacing) !important;
      mask-image: initial;
    }

    .shop-sidebar {
      max-height: initial !important;
    }

    .shop-sidebar__header {
      padding-top: 0 !important;
    }

    .shop-summary-navigation {
      position: static;
      background-image: none;
      background-color: var(--shop-header-background-dark);
    }
  }

  &-navigation {
    grid-area: navigation;
    position: absolute;
    z-index: 1;
    padding: var(--shop-summary-spacing);

    width: 100%;
  }

  .shop-sidebar {
    display: flex;
    flex-direction: column;

    max-height: 100dvh;
    overflow-y: auto;

    z-index: 1;

    background-color: var(--shop-header-background);
  }

  .shop-sidebar__header {
    padding: var(--shop-summary-spacing);

    background-color: var(--shop-header-background-dark);

    h2 {
      line-height: 1;
    }
  }

  .shop-selections {
    overflow-y: auto;
    max-height: calc(100dvh);

    padding-block-start: calc(var(--shop-summary-spacing) * 3);
    padding-block-end: calc(var(--shop-summary-spacing) * 2);
    padding-inline: var(--shop-summary-spacing);

    @include onPhone {
      overflow-y: initial;
      max-height: initial;
    }
  }

  .shop-contact {
    padding: 0 var(--shop-summary-spacing) var(--shop-summary-spacing) var(--shop-summary-spacing);
    margin-top: auto;
  }

  .shop-cta {
    padding: var(--shop-summary-spacing);
    flex-shrink: 0;

    &:empty {
      display: none;
    }

    @include onPhone {
      max-width: 100dvw;
      overflow-x: auto;
    }
  }
}

$components: 'costbreakdown', 'selections', 'cta', 'sidebar';

@each $component in $components {
  .shop-#{$component} {
    grid-area: #{$component};
  }
}
</style>
